<template>
  <div>
    <Ckhcgl />
  </div>
</template>

<script>
  // 获取接口地址
  import Ckhcgl from '../components/ckhc/ckhcgl.vue'

  export default {
    name: 'Ckhc',
    components: {
      Ckhcgl
    },
    data() {
      return {}
    },
    created: function() {},
    methods: {}
  }
</script>

<style scoped>
</style>
